import * as React from 'react'
import { CircularProgress } from '@material-ui/core'

const Index = () => {
  return <CircularProgress style={{ display: 'block', margin: '0 auto' }} />
}

export default Index
